import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './DeleteConfirmModal.css';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message?: string;
  count?: number;
  itemName?: string;
  /** Подпись основной кнопки (по умолчанию «Удалить») */
  confirmButtonText?: string;
  iconSrc?: string;
  iconAlt?: string;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({ 
  isOpen, 
  onClose,
  onConfirm,
  message,
  count = 1,
  itemName = 'элемент(ов)',
  confirmButtonText = 'Удалить',
  iconSrc = '/icons/modals/delete-svgrepo.svg',
  iconAlt = 'Удалить',
}) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const modalContent = (
    <div className="delete-confirm-modal-overlay" onClick={onClose}>
      <div className="delete-confirm-modal" onClick={(e) => e.stopPropagation()}>
        <button 
          className="delete-confirm-modal-close"
          onClick={onClose}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="#084B7A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <div className="delete-confirm-modal-icon">
          <img src={iconSrc} alt={iconAlt} />
        </div>
        <h3 className="delete-confirm-modal-message">
          {message ?? `Удалить ${count} ${itemName}?`}
        </h3>
        <button 
          type="button"
          className="delete-confirm-modal-btn"
          onClick={handleConfirm}
        >
          {confirmButtonText}
        </button>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default DeleteConfirmModal;
